import { COLORS } from '@/styles/colors';
import { body, poppinsRegularFont } from '@/styles/typography';
import styled from 'styled-components';

export const AuthMessage = styled.div`
  color: ${COLORS.black};
  ${poppinsRegularFont};
  ${body};
`;
